import { createTheme } from '@mui/material/styles';

import { palette } from './palette';
import { typography } from './typography';
import { components } from './components';

export const oysterHrDefaultTheme = createTheme({
  palette,
  typography,
  // theme.spacing(3) will equal 3 * 2 = 6px
  spacing: 2,
  components,
});
